module.exports = __webpack_public_path__ + "img/tappy-big-black-bold.71afd332.svg";